import React, { memo } from 'react';
import '@xyflow/react/dist/style.css';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { LdgNodeData } from './useLdgGraphData';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
export const LdgGraphNode = memo(({
  data,
  selected
}: NodeProps<LdgNodeData>) => {
  const {
    colorSet
  } = data;
  return <div className={`
        relative min-w-[240px] rounded-xl border-2 shadow-sm transition-all duration-200 bg-white
        ${selected ? `border-[${colorSet.ring}] ring-4 ring-[${colorSet.ring}]/20 shadow-md scale-105 z-10` : 'border-slate-200 hover:border-slate-300'}
      `} style={{
    borderColor: selected ? colorSet.ring : undefined
  }} data-id="element-2787">
        {/* Target Handle (Incoming) */}
        <Handle type="target" position={Position.Left} className="w-3 h-3 border-2 border-white bg-slate-400" data-id="element-2788" />

        {/* Header */}
        <div className={`px-3 py-2 rounded-t-lg border-b border-slate-100 flex items-center justify-between ${colorSet.light}`} data-id="element-2789">
          <div className="flex items-center gap-2" data-id="element-2790">
            <div className={`w-2 h-2 rounded-full ${colorSet.bg}`} data-id="element-2791" />
            <span className={`text-xs font-bold uppercase tracking-wider ${colorSet.text}`} data-id="element-2792">
              {data.module}
            </span>
          </div>
          <div className="flex items-center gap-1.5" data-id="element-2793">
            <span className="text-xs font-mono font-medium text-slate-500 bg-white px-1.5 py-0.5 rounded shadow-sm border border-slate-100" data-id="element-2794">
              T{data.tier}
            </span>
            <span className={`text-xs font-bold px-1.5 py-0.5 rounded ${colorSet.bg} text-white shadow-sm`} data-id="element-2795">
              {data.levelCode}
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="p-3" data-id="element-2796">
          <div className="font-mono font-bold text-sm text-slate-800 mb-1 truncate" title={data.label} data-id="element-2797">
            {data.label}
          </div>
          <div className="text-xs text-slate-500 truncate" title={data.subSkill} data-id="element-2798">
            {data.skill} • {data.subSkill}
          </div>

          {/* Status Indicator */}
          <div className="mt-3 flex items-center justify-between" data-id="element-2799">
            <div className="flex items-center gap-1 text-xs" data-id="element-2800">
              <span className="text-slate-400" data-id="element-2801">Prereqs:</span>
              <span className="font-medium text-slate-700" data-id="element-2802">
                {data.prerequisites.length}
              </span>
            </div>
            {!data.hasContent && <div className="flex items-center gap-1 text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded text-[10px] font-medium border border-amber-100" data-id="element-2803">
                <AlertTriangle className="w-3 h-3" data-id="element-2804" />
                <span data-id="element-2805">No Content</span>
              </div>}
            {data.hasContent && <div className="flex items-center gap-1 text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded text-[10px] font-medium border border-emerald-100" data-id="element-2806">
                <CheckCircle2 className="w-3 h-3" data-id="element-2807" />
                <span data-id="element-2808">Active</span>
              </div>}
          </div>
        </div>

        {/* Source Handle (Outgoing) */}
        <Handle type="source" position={Position.Right} className="w-3 h-3 border-2 border-white bg-slate-400" data-id="element-2809" />
      </div>;
});
LdgGraphNode.displayName = 'LdgGraphNode';